import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import config from "../config";

const API = config.API_BASE_URL;

// Στοιχεία επιχείρησης (επωνυμία/ΑΦΜ/email τιμολόγησης/τηλέφωνο/διεύθυνση).
// P0 audit fix: μέχρι 6/8/2026 δεν υπήρχε πουθενά UI για αυτά — placeholder τιμές στη βάση.
export default function CompanyProfileCard() {
  const { t } = useTranslation();
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/company-profile`).then((r) => setForm(r.data)).catch(() => setForm(null));
  }, []);

  if (!form) return null;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const looksPlaceholder =
    /^0+$/.test(String(form.taxid || "")) || !/@/.test(String(form.email || ""));

  const save = async () => {
    setBusy(true);
    setMsg(null);
    setErr(null);
    try {
      await axios.put(`${API}/company-profile`, form);
      setMsg(t("Saved."));
    } catch (e) {
      const code = e?.response?.data?.error;
      setErr(
        code === "bad-taxid" ? t("Tax ID must be exactly 9 digits.")
        : code === "bad-email" ? t("Please enter a valid email address.")
        : code === "taxid-in-use" ? t("This Tax ID is already in use.")
        : t("Something went wrong — please try again.")
      );
    } finally {
      setBusy(false);
    }
  };

  const row = { display: "flex", gap: 8, alignItems: "center", marginBottom: 8, flexWrap: "wrap" };
  const label = { minWidth: 170, fontSize: 14 };
  const input = { padding: "8px 10px", border: "1px solid #d1d5db", borderRadius: 8, minWidth: 240, width: "auto" };

  return (
    <div style={{ border: "1px solid #e5e7eb", borderRadius: 10, padding: 16, marginBottom: 18, background: "#fff" }}>
      <h3 style={{ marginTop: 0 }}>{t("Business details")}</h3>
      {looksPlaceholder && (
        <div style={{ background: "#fffbeb", color: "#92400e", padding: "8px 12px", borderRadius: 8, marginBottom: 10, fontSize: 13.5 }}>
          ⚠ {t("Tax ID or billing email look incomplete — invoices and important emails need real values.")}
        </div>
      )}
      {msg && <div style={{ background: "#ecfdf5", color: "#047857", padding: "8px 12px", borderRadius: 8, marginBottom: 10, fontSize: 13.5 }}>{msg}</div>}
      {err && <div style={{ background: "#fef2f2", color: "#b91c1c", padding: "8px 12px", borderRadius: 8, marginBottom: 10, fontSize: 13.5 }}>{err}</div>}

      <div style={row}>
        <label style={label}>{t("Legal name")}</label>
        <input style={input} type="text" autoCapitalize="off" value={form.company || ""} onChange={set("company")} />
      </div>
      <div style={row}>
        <label style={label}>{t("Tax ID")}</label>
        <input style={input} type="text" autoCapitalize="off" inputMode="numeric" maxLength={9} value={form.taxid || ""} onChange={set("taxid")} />
      </div>
      <div style={row}>
        <label style={label}>{t("Billing email")}</label>
        <input style={input} type="email" autoCapitalize="off" value={form.email || ""} onChange={set("email")} />
      </div>
      <div style={row}>
        <label style={label}>{t("Phone")}</label>
        <input style={input} type="text" autoCapitalize="off" inputMode="tel" value={form.phone || ""} onChange={set("phone")} />
      </div>
      <div style={row}>
        <label style={label}>{t("Address")}</label>
        <input style={input} type="text" autoCapitalize="off" value={form.address || ""} onChange={set("address")} />
      </div>
      <div style={row}>
        <label style={label}>{t("Responsible person")}</label>
        <input style={input} type="text" autoCapitalize="off" value={form.responsible || ""} onChange={set("responsible")} />
      </div>
      <button
        onClick={save}
        disabled={busy}
        style={{ padding: "9px 16px", background: "#111827", color: "#fff", border: "none", borderRadius: 8, cursor: "pointer", fontSize: 14 }}
      >
        {t("Save")}
      </button>
    </div>
  );
}
